// Mock data for ECOMIND ENGINEERING landing page

export const companyInfo = {
  name: "ECOMIND ENGINEERING",
  tagline: {
    en: "Congolese Experts in Mines & Industries",
    fr: "Experts Congolais des Mines & Industries"
  },
  mission: {
    en: "To provide the expertise necessary for the industrial development of R.D. Congo, based on research and respect for moral values.",
    fr: "Fournir l'expertise nécessaire au développement industriel de la R.D. Congo, basée sur la recherche et le respect des valeurs morales."
  },
  vision: {
    en: "To become a major player with strong national and international expertise, possessing strategic and operational capabilities to solve industrial, mining, and environmental problems.",
    fr: "Devenir un acteur majeur avec une forte expertise nationale et internationale, possédant des capacités stratégiques et opérationnelles pour résoudre les problèmes industriels, miniers et environnementaux."
  },
  goal: {
    en: "To participate in the emergence of a Congolese middle class by reducing poverty through direct employment, while ensuring social profitability through environmental conservation and sustainable industrial development.",
    fr: "Participer à l'émergence d'une classe moyenne congolaise en réduisant la pauvreté par l'emploi direct, tout en assurant une rentabilité sociale par la conservation de l'environnement et le développement industriel durable."
  }
};

export const services = [
  {
    id: 1,
    icon: "flask",
    title: {
      en: "Chemical Engineering & Metallurgy",
      fr: "Ingénierie Chimique & Métallurgie"
    },
    description: {
      en: "Expert consultancy in chemical processes development and metallurgical operations for mining and industrial applications.",
      fr: "Conseil expert en développement de procédés chimiques et opérations métallurgiques pour applications minières et industrielles."
    }
  },
  {
    id: 2,
    icon: "mountain",
    title: {
      en: "Mining Consultancy",
      fr: "Conseil Minier"
    },
    description: {
      en: "Comprehensive mining services including design, optimization, planning of operations, and topographical surveys.",
      fr: "Services miniers complets incluant la conception, l'optimisation, la planification des opérations et les levés topographiques."
    }
  },
  {
    id: 3,
    icon: "leaf",
    title: {
      en: "Environmental & Social Impact Studies",
      fr: "Études d'Impact Environnemental & Social"
    },
    description: {
      en: "Detailed environmental assessments, sanitation services, and waste recycling solutions for sustainable operations.",
      fr: "Évaluations environnementales détaillées, services d'assainissement et solutions de recyclage des déchets pour des opérations durables."
    }
  },
  {
    id: 4,
    icon: "factory",
    title: {
      en: "Industrial Services",
      fr: "Services Industriels"
    },
    description: {
      en: "Industrial cleaning, sheet metal work, mechanical welding, and maintenance services for industrial facilities.",
      fr: "Nettoyage industriel, travail de tôlerie, soudage mécanique et services de maintenance pour installations industrielles."
    }
  },
  {
    id: 5,
    icon: "beaker",
    title: {
      en: "Chemistry Laboratory & Research",
      fr: "Laboratoire de Chimie & Recherche"
    },
    description: {
      en: "Advanced laboratory services and research support for mining and industrial development projects.",
      fr: "Services de laboratoire avancés et support de recherche pour projets de développement minier et industriel."
    }
  },
  {
    id: 6,
    icon: "users",
    title: {
      en: "Recruitment & Equipment Rental",
      fr: "Recrutement & Location d'Équipement"
    },
    description: {
      en: "Professional recruitment services and rental of field vehicles and heavy-duty equipment for industrial projects.",
      fr: "Services de recrutement professionnel et location de véhicules de terrain et équipements lourds pour projets industriels."
    }
  }
];

export const team = [
  {
    id: 1,
    icon: "atom",
    title: {
      en: "Metallurgist Engineers",
      fr: "Ingénieurs Métallurgistes"
    },
    description: {
      en: "Specialized experts in metallurgical processes and mineral extraction techniques.",
      fr: "Experts spécialisés en procédés métallurgiques et techniques d'extraction minérale."
    }
  },
  {
    id: 2,
    icon: "pickaxe",
    title: {
      en: "Mining Engineers",
      fr: "Ingénieurs Miniers"
    },
    description: {
      en: "Experienced professionals in mining operations, design, and optimization.",
      fr: "Professionnels expérimentés en opérations minières, conception et optimisation."
    }
  },
  {
    id: 3,
    icon: "flask-conical",
    title: {
      en: "Chemists & Environmentalists",
      fr: "Chimistes & Environnementalistes"
    },
    description: {
      en: "Dedicated specialists ensuring sustainable practices and environmental compliance.",
      fr: "Spécialistes dévoués assurant des pratiques durables et la conformité environnementale."
    }
  },
  {
    id: 4,
    icon: "trending-up",
    title: {
      en: "Economists",
      fr: "Économistes"
    },
    description: {
      en: "Strategic advisors for economic feasibility and project planning.",
      fr: "Conseillers stratégiques pour la faisabilité économique et la planification de projets."
    }
  }
];

export const partnerships = [
  {
    id: 1,
    name: "FASCO",
    fullName: "Fast Service Company",
    description: {
      en: "Partnership since December 2021 for industrial and mining design maintenance, plant startup operations, and consultancy services.",
      fr: "Partenariat depuis décembre 2021 pour la maintenance de conception industrielle et minière, les opérations de démarrage d'usine et les services de conseil."
    },
    year: "2021"
  },
  {
    id: 2,
    name: "KNTCH",
    fullName: "Katanga New Technology",
    description: {
      en: "Collaboration for house-keeping services at various mining sites and construction projects throughout the region.",
      fr: "Collaboration pour les services d'entretien ménager sur divers sites miniers et projets de construction dans toute la région."
    },
    year: "2021"
  }
];

export const projects = [
  {
    id: 1,
    title: {
      en: "Construction Materials Production Plant",
      fr: "Usine de Production de Matériaux de Construction"
    },
    category: {
      en: "Industrial Development",
      fr: "Développement Industriel"
    },
    description: {
      en: "Startup and operation consultancy for construction materials production facility in partnership with FASCO.",
      fr: "Conseil en démarrage et exploitation d'une installation de production de matériaux de construction en partenariat avec FASCO."
    }
  },
  {
    id: 2,
    title: {
      en: "Mining Operations Optimization",
      fr: "Optimisation des Opérations Minières"
    },
    category: {
      en: "Mining Consultancy",
      fr: "Conseil Minier"
    },
    description: {
      en: "Comprehensive design and optimization services for multiple mining operations in Katanga region.",
      fr: "Services complets de conception et d'optimisation pour plusieurs opérations minières dans la région du Katanga."
    }
  },
  {
    id: 3,
    title: {
      en: "Environmental Impact Assessment",
      fr: "Évaluation de l'Impact Environnemental"
    },
    category: {
      en: "Environmental Services",
      fr: "Services Environnementaux"
    },
    description: {
      en: "Detailed environmental and social impact studies for major industrial and mining projects.",
      fr: "Études détaillées d'impact environnemental et social pour de grands projets industriels et miniers."
    }
  },
  {
    id: 4,
    title: {
      en: "Chemical Process Development",
      fr: "Développement de Procédés Chimiques"
    },
    category: {
      en: "Research & Development",
      fr: "Recherche & Développement"
    },
    description: {
      en: "Innovative chemical process development for mineral extraction and industrial applications.",
      fr: "Développement de procédés chimiques innovants pour l'extraction minérale et les applications industrielles."
    }
  }
];

export const researchStats = {
  projects: {
    number: "10+",
    label: {
      en: "Research Projects",
      fr: "Projets de Recherche"
    },
    description: {
      en: "Supporting university initiatives for young engineers and researchers",
      fr: "Soutien aux initiatives universitaires pour jeunes ingénieurs et chercheurs"
    }
  },
  focus: {
    en: "Mining and Industrial Sectors",
    fr: "Secteurs Minier et Industriel"
  },
  commitment: {
    en: "Supporting the next generation of Congolese engineers entering the job market through practical research and development projects.",
    fr: "Soutenir la prochaine génération d'ingénieurs congolais entrant sur le marché du travail par des projets de recherche et développement pratiques."
  }
};

export const coreValues = [
  {
    id: 1,
    icon: "search",
    title: {
      en: "Research Excellence",
      fr: "Excellence en Recherche"
    },
    description: {
      en: "Committed to continuous research and innovation in mining and industrial development.",
      fr: "Engagement envers la recherche continue et l'innovation dans le développement minier et industriel."
    }
  },
  {
    id: 2,
    icon: "shield-check",
    title: {
      en: "Moral Values",
      fr: "Valeurs Morales"
    },
    description: {
      en: "Upholding the highest ethical standards in all our operations and partnerships.",
      fr: "Respecter les normes éthiques les plus élevées dans toutes nos opérations et partenariats."
    }
  },
  {
    id: 3,
    icon: "award",
    title: {
      en: "Quality Service",
      fr: "Service de Qualité"
    },
    description: {
      en: "Delivering universal standards and cutting-edge technology solutions.",
      fr: "Fournir des normes universelles et des solutions technologiques de pointe."
    }
  },
  {
    id: 4,
    icon: "graduation-cap",
    title: {
      en: "Continuous Training",
      fr: "Formation Continue"
    },
    description: {
      en: "Investing in the development and training of our multidisciplinary team.",
      fr: "Investir dans le développement et la formation de notre équipe multidisciplinaire."
    }
  }
];

export const contactInfo = {
  phone: ["+243 99 26 91 163", "+243 85 26 59 323"],
  email: "info@ecomindengdrc.com",
  address: {
    en: "Size 35B Avenue LUFUNGULA, Quartier Gambela 2, Lubumbashi, R.D. Congo",
    fr: "Parcelle 35B Avenue LUFUNGULA, Quartier Gambela 2, Lubumbashi, R.D. Congo"
  },
  registration: {
    rccm: "CD/L'SHI/RCCM/21-B-01412",
    idnat: "05-C2001-N94993P",
    tax: "A22818505"
  }
};
